import useAuth from '../hooks/auth-hooks';
import { awsApiInstance } from '../api/aws-api';

import { IUpdateCards, IPostCardsResponse } from '../models/cards.interface';
import { handleRouteError } from './route-helpers/route-error';

/**
 * Updates an individual card
 * 
 * @param {IUpdateCards} card the form data
 * 
 * @returns {IPostCardsResponse} the api response | error
 */
export const updateCard = async (card: IUpdateCards): Promise<IPostCardsResponse> => {
  try {
    const { userId } = useAuth()!;

    const modelData = {
      wpId: userId,
      cardNumber: card.cardNumber,
      cardGroupId: card.cardGroupId,
      cardStatus: card.cardStatus
    };

    const { data } =  await awsApiInstance.put(`/cards/${card.cardNumber}`, modelData );

    return data;
  } catch ( error ) {
    handleRouteError(error, 'Error updating card');
    throw(error);
  }
};